module.exports = __webpack_public_path__ + "static/media/rate.ee8c46b5.svg";